module.exports = __webpack_public_path__ + "static/media/banjihagames-logo-mid.ab89e5c2.png";